var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.25,
    height: 19.25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16679",
    d: "M9.625 0a9.581 9.581 0 1 0 6.819 2.806A9.625 9.625 0 0 0 9.625 0Zm3.631 12.031a.919.919 0 0 1 .175 1.181.875.875 0 0 1-1.356.088l-2.45-2.45-2.45 2.45a.875.875 0 0 1-1.356-.088.919.919 0 0 1 .175-1.181L8.4 9.625 5.994 7.219a.962.962 0 0 1-.175-1.181.875.875 0 0 1 1.356-.088l2.45 2.45 2.45-2.45a.875.875 0 0 1 1.356.087.963.963 0 0 1-.175 1.181L10.85 9.625Z",
    fill: "#ff5d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.6122cd7d45f89199f95de9d59039481d.svg";
export { ForwardRef as ReactComponent };